"use client";

import { ArrowLeftIcon, Button } from "@pharaday/lighthouse";
import { useRouter } from "next/router";

const BackButton = () => {
  const router = useRouter();
  return (
    <Button icon color="primary" variant="light" size="sm" onClick={router.back}>
      <ArrowLeftIcon className="h-5 w-5" />
    </Button>
  );
};

export default BackButton;
